import './Quantity.css';
import React, { JSX } from 'react';

type QuantityProps = {
  readonly disabled: boolean;
  readonly value: number;
  readonly setValue: (value: number) => void;
};

export const Quantity = ({ disabled, value, setValue }: QuantityProps): JSX.Element => {
  function handleChangeValue(event: React.ChangeEvent<HTMLInputElement>) {
    const { value: targetValue } = event.target;

    if (targetValue === '' || !/^\d+$/.test(targetValue)) {
      setValue(0);
    } else {
      setValue(parseInt(targetValue));
    }
  }

  function decrement() {
    if (value > 1) {
      setValue(value - 1);
    }
  }

  function increment() {
    setValue(value + 1);
  }

  return (
    <div className="quantity">
      <button disabled={disabled} onClick={decrement} className="quantity__button">
        -
      </button>
      <div className="quantity__display">
        <input
          type="text"
          value={value}
          disabled={disabled}
          className="quantity__input"
          onChange={handleChangeValue}
          data-cy="input-quantity"
        />
      </div>
      <button disabled={disabled} onClick={increment} className="quantity__button">
        +
      </button>
    </div>
  );
};
